export const TEMPLATE_TYPE = {
  email: 'email',
  sms: 'sms',
} as const

export type TemplateType = (typeof TEMPLATE_TYPE)[keyof typeof TEMPLATE_TYPE]
